export const convertForSelect = (data, key = "value") => {
    const optionData = data?.map((item) => ({
        value: item?._id,
        label: item?.[key]
    }));
    return optionData;
}

export const convertForCheckbox = (data) => {
    const optionData = data?.map((item) => ({
        label: item?.value,
        value: item?._id
    }));
    return optionData;
}
export const truncateValue = (value, maxLength = 30) => {
  if (typeof value !== "string") value = value?.toString?.() ?? "";
  if (!value) return "-";
  return value.length > maxLength ? value.slice(0, maxLength) + "..." : value;
}